import React from 'react';
import PropTypes from 'prop-types';

import { SILVER_SAND } from '@constant/colors';

export default class Close extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    hoverColor: PropTypes.string,
    onClick: PropTypes.func,
    tabIndex: PropTypes.number,
    label: PropTypes.string,
  };

  static defaultProps = {
    color: SILVER_SAND,
  };

  state = {
    hover: false,
  };

  render() {
    const {
      className,
      color,
      hoverColor,
      onClick,
      tabIndex,
      label,
    } = this.props;

    const fillColor = this.state.hover && hoverColor ? hoverColor : color;

    return (
      <svg
        viewBox="0 0 24 24"
        className={className}
        tabIndex={tabIndex}
        onMouseOut={() => this.setState({ hover: false })}
        onMouseOver={() => this.setState({ hover: true })}
        onClick={onClick}
        aria-label={label}
      >
        <path
          fill={fillColor}
          fillRule="evenodd"
          d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zm-10-1.414L9.875 8.46c-.38-.38-1.02-.386-1.41.004-.394.394-.393 1.023-.004 1.41L10.587 12 8.46 14.125c-.38.38-.386 1.02.004 1.41.394.394 1.023.393 1.41.004L12 13.413l2.125 2.125c.38.38 1.02.386 1.41-.004.394-.394.393-1.023.004-1.41L13.413 12l2.125-2.125c.38-.38.386-1.02-.004-1.41-.394-.394-1.023-.393-1.41-.004L12 10.587zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
        />
      </svg>
    );
  }
}
